import { getField, updateField } from 'vuex-map-fields';
import {
  cargarPaginaPrincipal as cargarPaginaPrincipalServicio,
  guardarPaginaPrincipal as guardarPaginaPrincipalServicio,
} from 'views/components/crm/components/sitio_web/composables/pagina_principal_service';

export default {
  namespaced: true,
  state: {
    cargando: false,
    guardando: false,
    medios_pago: [],
    principal: {
      empresa: {
        logo: '',
      },
      calificaciones: {},
      servicios: {},
      vehiculos: {},
      banner1: {},
      banner2: {},
      datos_contacto: {
        telefonos: [{}, {}],
        correos: [{}],
      },
      redes_sociales: {},
      presentacion: {},
      form_contacto: {},
      beneficios: {},
      seo: {},
      footer: {
        contacto: {
          titulo: '',
        },
        about_us: {
          titulo: '',
          descripcion: '',
        },
        enlaces: {
          titulo: '',
        },
      },
      orden_secciones: [],
      medios: {},
      conoce_mas: {
        redes_sociales: {
          facebook: '',
        },
      },
    },
    secciones: {},
  },
  getters: {
    getField,
  },
  mutations: {
    SET_CARGANDO(state, cargando) {
      state.cargando = cargando;
    },
    SET_DATOS_PAGINA_PRINCIPAL(state, datos) {
      state.principal = datos.principal;
      state.medios_pago = datos.medios_pago;
      state.secciones = datos.secciones;
    },
    SET_GUARDANDO(state, guardando) {
      state.guardando = guardando;
    },
    updateField,
  },
  actions: {
    async cargarPagina({ commit }, { baseUrl, httpCliente }) {
      commit('SET_CARGANDO', true);
      try {
        const datos = await cargarPaginaPrincipalServicio(httpCliente, baseUrl);
        commit('SET_DATOS_PAGINA_PRINCIPAL', datos);
        return datos;
      } finally {
        commit('SET_CARGANDO', false);
      }
    },
    async guardarPagina({ commit, state }, { baseUrl, httpCliente }) {
      commit('SET_GUARDANDO', true);
      try {
        await guardarPaginaPrincipalServicio(httpCliente, baseUrl, state.principal, state.secciones);
      } finally {
        commit('SET_GUARDANDO', false);
      }
    },
  },
};
